<div class="container-idle" [class.show]="">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Edita una factura</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="close.emit(false)"></i></h1>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm form-group">
							<label for="code" class="form-label">Serie</label>
							<input type="text" [(ngModel)]="newSale.series" placeholder="Ingresa la serie de la factura"
								name="code" id="code" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="number" class="form-label">Número</label>
							<input type="text" [(ngModel)]="newSale.number"
								placeholder="Ingresa el número de la factura" name="number" id="number"
								class="form-control">
						</div>
						<div class="col-sm form-group">
							<label for="lot" class="form-label">Lote</label>
							<input type="text" [(ngModel)]="newSale.lot" placeholder="Ingresa el lote" name="lot"
								id="lot" class="form-control">
						</div>
					</div>
					<div class="row">
						<div class="col-sm form-group">
							<label for="date" class="form-label">Fecha <span class="required">*</span></label>
							<input type="date" name="date" id="date" [(ngModel)]="newSale.date" class="form-control">
						</div>
						<div class="col-sm form-group">
							<label class="form-label">{{(isClient)?'Cliente':'Proveedor'}}
								<span class="required">*</span>
								<span class="clickeable" (click)="createVendor()"><i class="fa fa-plus"></i></span>
							</label>
							<div class="input-group input-group-sm">
								<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.client"
									[placeholder]="'Ingresa un cliente'" [filterElements]="filter"
									[typeElements]="'client'" 
									(inputMethod)="writeClient($event.event)"
									(changeStatus)="check($event.filterElement)"
									(getTitle)="$event.filterElement.title = $event.filterElement.name"></app-input-autocomplete>
							</div>
						</div>
						<div class="col-sm form-group">
							<label for="description" class="form-label">Observaciones</label>
							<input type="text" [(ngModel)]="newSale.description"
								placeholder="Ingresa una observacion" name="description" id="description"
								class="form-control">
						</div>
					</div>
					<div class="table-responsive">
						<table class="table table-striped">
							<thead>
								<tr>
									<!-- Cantidad	Producto	Descripcion	Precio	Total -->
									<th class="td-center">
										Cantidad
									</th>
									<th>
										Producto
									</th>
									<th>
										Descripción
									</th>
									<th class="td-center">
										Precio
									</th>
									<th class="td-center">
										Total
									</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let product of newSale['detail']">
									<td class="td-center">{{product.quantity}}</td>
									<td>{{product.productData.name}}</td>
									<td>{{product.productData.description}}</td>
									<td class="td-center">{{product.price+product.taxes | currency : 'Q. '}}</td>
									<td class="td-center">{{product.quantity * (product.price+product.taxes) | currency
										: 'Q. '}}</td>
								</tr>
							</tbody>
							<tfoot>
								<tr>
									<td colspan="4">Total</td>
									<td colspan="4" class="td-center">{{newSale.balance | currency : 'Q. '}}</td>
								</tr>
							</tfoot>
						</table>
					</div>
					<p class="text-muted" style="margin-top: 1em; font-size: 0.8em; text-align: right;"><i
							class="fa fa-circle-info"></i>Completa los campos marcados con un <span
							class="required">*</span> para guardar los cambios</p>
				</div>

				<div class="modal-footer">
					<button class="btn btn-success" [disabled]="!newSale.date || loading" (click)="putInvoice()">
						<ng-container *ngIf="!loading">
							<i class="fa fa-floppy-disk"></i>
						</ng-container>
						<ng-container *ngIf="loading">
							<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							<span role="status"></span>
						</ng-container>GUARDAR
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal-vendor *ngIf="creating" [isCreating]="creating" [newVendor]="newVendor"
	(close)="creating = false;"></app-modal-vendor>